export default __webpack_public_path__ + "static/media/CHI.c98e9fb8.svg";